var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiovideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_254)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#DC4726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.667 176.833C414.603 174.553 408.981 173.812 403.499 174.701C398.017 175.59 392.917 178.07 388.833 181.833L353 215.167V191C353 177.739 347.732 165.021 338.355 155.645C328.979 146.268 316.261 141 303 141H153C139.739 141 127.021 146.268 117.645 155.645C108.268 165.021 103 177.739 103 191V324.333C103 337.594 108.268 350.312 117.645 359.689C127.021 369.065 139.739 374.333 153 374.333H303C316.261 374.333 328.979 369.065 338.355 359.689C347.732 350.312 353 337.594 353 324.333V300.167L389 333.5C394.3 338.297 401.185 340.968 408.333 341C412.3 340.991 416.22 340.139 419.833 338.5C424.749 336.512 428.96 333.103 431.929 328.709C434.898 324.315 436.489 319.136 436.5 313.833V201.5C436.476 196.178 434.86 190.985 431.86 186.589C428.86 182.193 424.614 178.796 419.667 176.833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiovideo);
export default __webpack_public_path__ + "static/media/audiovideo.248ae21c5bd2d4e9925da9f7ced40610.svg";
export { ForwardRef as ReactComponent };